import { Box, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useRef, useState } from "react"
import styles from "./headerNotification.module.scss"
import AppTextField from "components/StyledComponents/AppTextField"
import { useDispatch, useSelector } from "react-redux"
import {
  createHeaderNotificationAction,
  getHeaderNotificationAction
} from "redux/superAdmin/actions"
import { Formik } from "formik"
import { validationSchemaHeaderNotification } from "helpers/validationSchema"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

const HeaderNotification = () => {
  const [breadCrumbs, setBreadCrumbs] = useState([])
  const { headerNotificationData } = useSelector((state) => state.superAdmin)
  const dispatch = useDispatch()
  const history = useHistory()
  const formikRef = useRef()

  const initialValues = () => {
    return {
      headerType: headerNotificationData
        ? headerNotificationData.is_enabled
          ? "custom"
          : "automated-coins-header"
        : "",
      customText: headerNotificationData
        ? headerNotificationData.is_enabled
          ? headerNotificationData.custom_text
          : ""
        : ""
    }
  }

  const handleChange = (e) => {
    const value = e.target.value
    formikRef.current.setFieldValue("headerType", value)
    formikRef.current.setFieldValue("customText", "")
  }

  const handleSave = (values) => {
    const payload = {
      is_enabled: values?.headerType === "automated-coins-header" ? false : true,
      ...(values?.headerType === "custom" && { custom_text: values?.customText })
    }

    dispatch(
      createHeaderNotificationAction({
        payload,
        handleRoute: () => history.push("/super-admin/dashboard")
      })
    )
  }

  useEffect(() => {
    document.title = "Header Notification"
    setBreadCrumbs(createBreadcrumbs())
    dispatch(getHeaderNotificationAction())
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Header title="Header Notification" breadCrumbs={breadCrumbs}>
          <AppButton
            className={styles.saveBtn}
            onClick={() => {
              if (formikRef.current) {
                formikRef.current.submitForm()
              }
            }}>
            Save
          </AppButton>
        </Header>
      </Grid>

      <Formik
        innerRef={formikRef}
        initialValues={initialValues()}
        onSubmit={handleSave}
        validationSchema={validationSchemaHeaderNotification}
        enableReinitialize>
        {(formik) => (
          <Grid item xs={12}>
            <Box className={styles.container}>
              <Typography variant="body1small">Create</Typography>
              <RadioGroup
                row
                name="headerType"
                value={formik.values.headerType}
                onChange={handleChange}>
                <Grid className="mt-1" container spacing={2}>
                  <Grid item xs={6}>
                    <Box
                      className={
                        formik.values.headerType === "automated-coins-header"
                          ? styles.activeRadioBox
                          : styles.radioBox
                      }>
                      <FormControlLabel
                        value="automated-coins-header"
                        control={<Radio color="secondary" />}
                        label={<Typography variant="body1small">Automated coins header</Typography>}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      className={
                        formik.values.headerType === "custom"
                          ? styles.activeRadioBox
                          : styles.radioBox
                      }>
                      <FormControlLabel
                        value="custom"
                        control={<Radio color="secondary" />}
                        label={<Typography variant="body1small">Custom</Typography>}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </RadioGroup>

              <AppTextField
                className="mt-4"
                label="Notification Text"
                placeholder="Enter Text"
                fullWidth
                name="customText"
                value={formik.values.customText}
                isDisabled={formik.values.headerType === "automated-coins-header"}
                isUpperCase={true}
                isRequired={true}
                onChange={formik.handleChange}
                error={formik.touched.customText && Boolean(formik.errors.customText)}
                helperText={formik.touched.customText && formik.errors.customText}
              />
            </Box>
          </Grid>
        )}
      </Formik>
    </Grid>
  )
}

export default HeaderNotification
